define('skylark-utils-dom/skylark',["skylark-langx/skylark"], function(skylark) {
    return skylark;
});

define('skylark-utils-dom/dom',["./skylark"], function(skylark) {
	return skylark.dom = skylark.attach("dom",{});
});

define('skylark-utils-dom/browser',[
    "./dom",
    "skylark-domx-browser"
], function(dom,browser) {
    "use strict";

    return dom.browser = browser;
});

define('skylark-utils-dom/css',[
    "./dom",
    "skylark-domx-css"
], function(dom, css) {
    "use strict";

     return dom.css = css;
});

define('skylark-utils-dom/datax',[
    "./dom",
    "skylark-domx-data"
], function(dom, datax) {
 
    return dom.datax = datax;
});
define('skylark-utils-dom/eventer',[
    "./dom",
    "skylark-domx-eventer"
], function(dom, eventer) {
 
    return dom.eventer = eventer;
});
define('skylark-utils-dom/finder',[
    "./dom",
    "skylark-domx-finder"
], function(dom, finder) {

    return dom.finder = finder;
});
define('skylark-utils-dom/fx',[
    "./dom",
    "skylark-domx-fx"
], function(dom, fx) {
    return dom.fx = fx;
});
define('skylark-utils-dom/geom',[
    "./dom",
    "skylark-domx-geom"
], function(dom, geom) {

    return dom.geom = geom;
});
define('skylark-utils-dom/images',[
    "./dom",
    "skylark-domx-images"
], function(dom,images) {
  return dom.images = images;
});

define('skylark-utils-dom/noder',[
    "./dom",
    "skylark-domx-noder"
], function(dom, noder) {

    return dom.noder = noder;
});
define('skylark-utils-dom/plugins',[
    "./dom",
    "skylark-domx-plugins"
], function(dom, plugins) {
    "use strict";


    return dom.plugins = plugins;
});
define('skylark-utils-dom/query',[
    "./dom",
    "skylark-domx-query"
], function(dom, query) {

    return dom.query = query;

});
define('skylark-utils-dom/scripter',[
    "./dom",
    "skylark-domx-scripter"
], function(dom, scripter) {

    return dom.scripter = scripter;
});
define('skylark-utils-dom/styler',[
    "./dom",
    "skylark-domx-styler"
], function(dom, styler) {

    return dom.styler = styler;
});
define('skylark-utils-dom/transforms',[
    "./dom",
    "skylark-domx-transforms"
], function(dom,transforms) {
  return dom.transforms = transforms;
});

define('skylark-utils-dom/langx',[
    "skylark-langx/langx"
], function(langx) {
    return langx;
});

define('skylark-utils-dom/elmx',[
    "./dom",
    "skylark-domx-velm"
], function(dom, elmx) {
     return dom.elmx = elmx;
});
define('skylark-utils-dom/main',[
    "./dom",
    "./browser",
    "./css",
    "./datax",
    "./eventer",
    "./finder",
    "./fx",
    "./geom",
    "./images",
    "./noder",
    "./plugins",
    "./query",
    "./scripter",
    "./styler",
    "./transforms",
    "./langx",
    "./elmx"
], function(dom) {
    return dom;
})
;
define('skylark-utils-dom', ['skylark-utils-dom/main'], function (main) { return main; });

